import firebase from "firebase";
import "firebase/auth";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyA7XwOoq9oPNa4C2e1yXC9xNx66ka5Jftw",
  authDomain: "shopping-list-a16c1.firebaseapp.com",
  databaseURL: "https://shopping-list-a16c1.firebaseio.com",
  projectId: "shopping-list-a16c1",
  storageBucket: "shopping-list-a16c1.appspot.com",
  messagingSenderId: "771889406512",
  appId: "1:771889406512:web:0d4f508eeeaac5fbecc3f5"
};
firebase.initializeApp(config);

export const db = firebase.firestore();
export const auth = firebase.auth();
